import { toast } from "react-toastify";
import router from "../../core/routes";

import { updateSpecificMessageStatusApi } from "../../api/dashboardApi";
import { handleUnauthorizedError } from "../../api/helpers/handleErrorResponses.util";
import { createChatMessage } from "../../components/dashboard/messages/SeletectedChat";
import { updateDashboardChatListItem } from "../../redux/actions/dashboard/dashboardActions";
import {
  adjustUnreadMessagesCout,
  updateUnreadMessagesCout,
} from "../../redux/actions/profile/profileActions";
import store from "../../redux/reduxStore";

function receiveMessageEvent(data) {
  const message = data.message;

  // 3 scenerios
  // 1 .in the dashboard messages page not selected the chat - update the chat list unread count and the badge count
  // 2. in the  dashboard messages page but selected the chat - update the chat
  // 3. not in the dashboard messages page - update the badge count

  const chatBookingId = message.bookingDetails.id;

  toast.info(
    `Message from ${message.propertyDetails.name}: ${message.message}`,
    {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      onClick: () => {
        router.navigate(`/dashboard/messages?bookingId=${chatBookingId}`);
      },
    }
  );

  const currentLocation = window.location.pathname;
  const isDashboardMessagesPage = currentLocation.includes(
    "/dashboard/messages"
  );

  store.dispatch(adjustUnreadMessagesCout({ count: 1 }));
  store.dispatch(updateDashboardChatListItem({ message, count: 1 }));

  if (isDashboardMessagesPage) {
    const bookingId =
      Number(new URLSearchParams(window.location.search).get("bookingId")) ||
      null;

    if (bookingId === chatBookingId) {
      const chatBody = document.getElementById("chat-body");
      const messagesContainer = document.getElementById("messages-container");

      const lastDayContainer = messagesContainer?.querySelector(
        ".chat-day-container:last-child .chat-day-body"
      );

      if (!messagesContainer || !lastDayContainer) {
        return;
      }

      const msgElement = createChatMessage(message);

      lastDayContainer.appendChild(msgElement);
      chatBody.scrollTop = chatBody.scrollHeight;

      updateSpecificMessageStatusApi({ bookingId, messageIds: [message.id] })
        .then((res) => {
          store.dispatch(
            updateUnreadMessagesCout({
              count: res.data.totalUnseenCount,
            })
          );
        })
        .catch((err) => {
          if (err.status === 401) {
            return handleUnauthorizedError(err);
          }
        });
    }
  }
}

export default receiveMessageEvent;
